// tslint:disable:no-empty
// import { navigate } from '@reach/router';
import React, { useEffect, useState } from 'react';
import Loading from '../components/utils/Loading';
import client from '../lib/client';
import { logger } from '../lib/helpers';
import {
  SelectedNotebook,
  SelectedNotebookVariables
} from '../queries/__generated__/SelectedNotebook';
import { selectedNotebookQuery } from '../queries/notebooks';
import { Notebook } from './notebook';
import redirect from '../lib/redirect';

export const SELECTED_NOTEBOOK_ID = 'selectedNotebookId';

interface NotebookContext {
  notebook: Notebook;
  reloadNotebook: () => void;
}

const NotebookContext = React.createContext<NotebookContext>({
  notebook: Notebook.emptyNotebook(),
  reloadNotebook: () => {}
});

interface NotebookProviderProps {
  children: React.ReactNode;
  initialNotebookId: string;
}

const NotebookProvider: React.FC<NotebookProviderProps> = ({ children, initialNotebookId }) => {
  const [notebook, setNotebook] = useState(Notebook.emptyNotebook());
  const [loading, setLoading] = useState(true);

  async function getNotebook(newNotebookId: string) {
    await client
      .query<SelectedNotebook, SelectedNotebookVariables>({
        query: selectedNotebookQuery,
        variables: { id: newNotebookId },
        fetchPolicy: 'network-only'
      })
      .then(res => {
        if (res.errors) {
          logger(res.errors);
        }
        if (res.data.notebook) {
          setNotebook(new Notebook(res.data.notebook));
        }
      })
      .catch(() => redirect('/'));

    setLoading(false);
    return notebook;
  }

  useEffect(() => {
    getNotebook(initialNotebookId);
  }, []);

  if (loading) {
    return <Loading />;
  }

  async function reloadNotebook() {
    await getNotebook(initialNotebookId);
  }

  return (
    <NotebookContext.Provider value={{ notebook, reloadNotebook }}>
      {children}
    </NotebookContext.Provider>
  );
};

export { NotebookContext, NotebookProvider };
